import "./setupApiClient";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import './theme.css';
import './mobile.css';   // ← full mobile compatibility layer
import App from './App';
import AppToaster from './utils/AppToaster';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <App />
      <AppToaster />
    </ConfigProvider>
  </React.StrictMode>
);

reportWebVitals();
